<template>
  <div>
    <CpTextEditor
      :text="text"
      placeholder="Write a comment..."
      @sendMessage="sendMessage"
      :withBackground="false"
      :primaryBtnType="false"
      :loadingSend="loading"
      :isMessagingToRep="sendToRep"
    />
  </div>
</template>

<script>
import CpTextEditor from '../components/TextEditor';

export default {
  data() {
    const name = this.tag ? this.tag.name + ' - ' : '';
    return {
      text: name,
      loading: false,
    };
  },

  methods: {
    async sendMessage(e, data) {
      e.preventDefault();
      this.loading = true;
      await this.send(data);
      this.loading = false;
    },
  },

  props: {
    send: { type: Function },
    tag: Object,
    buttonText: String,
    reply: Boolean,
    type: String,
    sendToRep: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    CpTextEditor,
  },
};
</script>
